let hideInit = document.querySelectorAll('.hide-has-js');
hideInit.forEach(e=> {
    e.classList.remove('hide-has-js')
})